import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// The API only accepts its own origin (CORS); a page opened from another host of the same app moves there.
const apiOrigin = new URL(process.env.REACT_APP_BACKEND_URL).origin;
const offHost = window.location.origin !== apiOrigin && window.location.hostname !== "localhost";
if (offHost) window.location.replace(apiOrigin + window.location.pathname + window.location.search + window.location.hash);

const root = ReactDOM.createRoot(document.getElementById("root"));
if (!offHost) root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
